import React from 'react'

import singleBonusImage from '@assets/bonus-system/Single_Bonus_image.png'
import { DeclineTemplate } from '@components/BonusSystemCommon'
import { buildGradientStyle } from '@utils/buildGradientStyle'
import { DeclineBonusInfo, DeclineBonusStyles } from '@components/BonusSystemCommon/content/DeclineTemplate'
import { useTranslation } from '@amusnet/translations/react'
import { Bonus } from 'game-ui-types'

interface FSDeclineProps {
    bonus?: Bonus
}

const FSDecline: React.FC<FSDeclineProps> = ({ bonus }) => {
    const { t } = useTranslation()

    const bundleType = bonus ? t('gameui.bonusSystem.freeSpin', undefined, Number(bonus.remainingAmount)) : ''

    const bonusInfo: DeclineBonusInfo | undefined = bonus && {
        betValue: bonus.betValue,
        bundleDetails: [
            { text: bonus.remainingAmount ?? '', styles: 'text-9xl font-black text-yellow-400 leading-tight' },
            { text: bundleType, styles: 'text-4xl font-black text-yellow-400 leading-snug' },
        ],
    }

    const styles: DeclineBonusStyles = {
        primaryTextColor: 'text-white',
        secondaryTextColor: 'text-yellow-400',
        background: buildGradientStyle(['#19191C 19.44%', '#793F06 100%'], '180deg'),
        image: singleBonusImage,
    }

    return <DeclineTemplate bonusInfo={bonusInfo} styles={styles} />
}

export default FSDecline
